import { CampaignFormMode, CampaignSelectedSalesMaterialItem } from 'src/app/modules/PulseLeads/types/campaign-types';

export type CampaignMaterialSelectionDraft = {
  formState?: any;
  selectedSalesMaterials?: CampaignSelectedSalesMaterialItem[];
  returnPath?: string;
};

const MATERIAL_SELECTION_DRAFT_STORAGE_KEY = 'pulseleads-campaign-material-selection-draft';

export const getCampaignMaterialSelectionDraftKey = (formMode: CampaignFormMode, campaignId?: string) => {
  return `${MATERIAL_SELECTION_DRAFT_STORAGE_KEY}:${formMode}:${campaignId || 'create'}`;
};

export const loadCampaignMaterialSelectionDraft = (draftKey: string): CampaignMaterialSelectionDraft | undefined => {
  const rawValue = sessionStorage.getItem(draftKey);

  if (!rawValue) {
    return undefined;
  }

  try {
    return JSON.parse(rawValue) as CampaignMaterialSelectionDraft;
  } catch (error) {
    sessionStorage.removeItem(draftKey);
    return undefined;
  }
};

export const saveCampaignMaterialSelectionDraft = (draftKey: string, draft: CampaignMaterialSelectionDraft) => {
  sessionStorage.setItem(draftKey, JSON.stringify(draft));
};

export const clearCampaignMaterialSelectionDraft = (draftKey: string) => {
  sessionStorage.removeItem(draftKey);
};
